import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TYPOGRAPHY } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: ISA REFACTOR
merge(addToCartButtonStyles, {
    button: {
        css: css`
            width: auto;
            min-width: 115px;
            font-size: ${TYPOGRAPHY.size.base};
            display: inline-block;
            height: 48px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            height: 40px;
                            margin: 0 !important;
                            width: 100%;
                        `,
                        css`
                            max-width: 100%;
                            height: 48px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
});
